import { DISEASES } from '@/constants/disease'

export class AttendanceConfig {
  #steps = []
  #originalPhases = []
  #phases = []
  #summaryComponent = null
  #hypothesisComponent = null

  setStepPhase(stepIndex, phases) {
    this.#phases[stepIndex] = [...phases]
  }
  getSteps() {
    return this.#steps
  }
  getStep(stepIndex) {
    return this.#steps[stepIndex]
  }
  getPhases(stepIndex) {
    return this.#phases[stepIndex]
  }
  getOriginalPhases(stepIndex) {
    return this.#originalPhases[stepIndex]
  }
  getAllPhases() {
    return this.#phases.flat()
  }
  getPhase(stepIndex, phaseIndex) {
    return this.getPhases(stepIndex)[phaseIndex]
  }
  getLastPhaseIndex(stepIndex) {
    return this.getPhases(stepIndex).length - 1
  }
  getLastStepIndex() {
    return this.#steps.length - 1
  }
  getSummaryComponent() {
    return this.#summaryComponent
  }
  getHypothesisComponent() {
    return this.#hypothesisComponent
  }

  addStep(name) {
    const index = this.#steps.length
    this.#steps.push({ name, index })
    this.#phases.push([])
    return this
  }

  addPhase(
    key,
    name,
    component,
    overviewGenerator = (phaseData, attendance) => null,
    isSummarized = true,
    extendedFlow = true,
  ) {
    if (this.#steps.length === 0) {
      throw new Error('You must define at least one step to add a phase!')
    }
    const lastItem = this.#phases[this.#phases.length - 1]
    lastItem.push({
      key,
      name,
      component,
      index: lastItem.length,
      overviewGenerator,
      isSummarized: isSummarized,
      extendedFlow: extendedFlow,
    })

    this.#originalPhases = [...this.#phases]

    return this
  }

  setSummaryComponent(component) {
    this.#summaryComponent = component
    return this
  }

  setHypothesisComponent(component) {
    this.#hypothesisComponent = component
    return this
  }
}
export function getAttendanceConfig(diseaseId, mode = 'normal', version = 1) {
  if (!diseaseId) {
    return null
  }

  switch (diseaseId) {
    case DISEASES.ESPONDILOARTRITIS:
      return require('./espondiloartritesConfig')[mode]
    case DISEASES.PSORIASIS:
      return require('./psoriasisConfig')[`configV${version ?? 1}`]
    case DISEASES.GENERAL_CLINIC:
      return require('./generalClinicConfig').default
    case DISEASES.ATOPIC_DERMATITIS:
      return require('./atopicdermatitisConfig').default
    case DISEASES.CSU:
      return require('./csuConfig').default

    default:
      return require('./defaultConfig').default
  }
}
